import { useParams } from "react-router-dom";
import { nameOf } from "../../Utils/nameOf";
import { Branch } from "../Branch";
import Carrier from "../Carrier";
import { useFetchCarrierById } from "../Hooks/useFetchCarrierById";
import { useUpdateCarrier } from "../Hooks/useUpdateCarrier";
import CarrierFormTabs from "./CarrierFormTabs";
import { useDeleteCarrier } from "../Hooks/useDeleteCarrier";

export default function EditCarrier() {
  const { carrierId } = useParams();
  const { data: carrier } = useFetchCarrierById(carrierId);
  const { mutate: updateCarrier } = useUpdateCarrier();
  const { mutate: deleteCarrier } = useDeleteCarrier();

  const disabledFields: Array<string> = [
    nameOf<Carrier>("Gsdb"),
    nameOf<Branch>("CarrierReference"),
    nameOf<Branch>("CountryIsoCode"),
  ];

  return (
    <CarrierFormTabs
      title="Edit Carrier"
      carrier={carrier}
      onSave={(it: Carrier) => updateCarrier(it)}
      onDelete={() => deleteCarrier(carrierId)}
      disabledFields={disabledFields}
    />
  );
}
